<template>
  <div class="header">
    <div class="inner fixed">
      <div class="logo">
        <a href="/index.html">
          <img class="logo_01" :src="commonInfo?.photo1" />
          <img class="logo_02" :src="commonInfo?.photo2" />
        </a>
      </div>
      <div class="nav_phone_btn" :class="{ visible_nav: showNav }" @click="toggleNav"><span></span></div>
      <nav class="nav fixed">
        <div class="rr_top">
          <div class="mem" @mouseenter="showMenu = true">
            <i v-if="userInfo" class="icon-ren fnt_20"></i>
            <i v-if="!userInfo" @click="logInAndlogOutClick('logIn')" class="icon-ren fnt_20"></i>
            <!--登录状态显示这些-->
            <em v-if="userInfo" class="fnt_14 userInfoName">会员：{{ userInfo.title }}</em>
            <i v-if="userInfo" class="icon-icon fnt_20"></i>
            <div v-if="userInfo" v-show="showMenu" class="mem_xiala">
              <router-link to="/member/index">
                <a href="javascript:void(0)">会员中心</a>
              </router-link>
              <router-link to="/product/shoppingCart">
                <a href="javascript:void(0)">购物车</a>
              </router-link>
              <a href="javascript:void(0)" @click="logInAndlogOutClick('logOut')">退出登录</a>
            </div>
            <!--登录状态end-->
            <!--未登录状态显示这些-->
            <em v-if="!userInfo" class="fnt_14" @click="logInAndlogOutClick('logIn')"><a
                href="javascript:void(0)">登录</a></em>
            <!--未登录状态end-->
          </div>

          <div class="ser fnt_20">
            <a href="javascript:void(0)"><i class="icon-sousuo"></i></a>
          </div>
          <div class="search_wrap">
            <input type="text" v-model="iptValue" placeholder="请输入关键字" class="search_box_text" />
            <button class="search_box_button fnt_20" @click="searchBtn">
              <i class="icon-sousuo"></i>
            </button>
          </div>
        </div>
        <ul class="fixed">
          <li>
            <a href="/index.html">首页<em></em></a>
          </li>
          <li :class="{ on: !isAuthPage }">
            <a @click="productListBtn" href="javascript:void(0)">产品中心<em></em></a>
          </li>
          <li>
            <a href="/application/index.html">应用场景<em></em></a>
          </li>
          <li>
            <a href="/service/index.html">服务<em></em></a>
          </li>
          <li>
            <a href="/cooperation/index.html">合作<em></em></a>
          </li>
          <li>
            <span class="icon-icon"></span>
            <a href="/resource/index.html">资源中心<em></em></a>
            <div class="navlist fixed">
              <dl class="fixed">
                <dd><a href="/resource/product.html">产品与资料</a></dd>
                <dd><a href="/resource/knowledge.html">知识中心</a></dd>
                <dd><a href="/resource/industry.html">产业版图</a></dd>
              </dl>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import $ from 'jquery';
import {
  getUserInfo,
} from "@/api/member"; //会员中心接口
import { setWithExpiry, getWithExpiry } from '@/utils/storage-ttl'; // 本地存储加时效性封装文件

export default {
  data() {
    return {
      showMenu: false, //控制菜单显示
      userInfo: null, //获取登录基本信息
      showNav: false, //控制移动端导航显示
      commonInfo: null, //获取公共信息
      iptValue: '', //搜索关键词
    };
  },
  watch: {
    $route(to, from) {
      if (getWithExpiry('logInInfo')) {
        this.init();
      }else{
        this.userInfo = null;
      }
    },
  },
  computed: {
    // 登录、注册页面不高亮「产品中心」
    isAuthPage() {
      return ['login', 'register', 'forget', 'forgetphone'].includes(this.$route.name);
    },
  },
  mounted() {
    // 页面加载时清除body上可能残留的导航类
    document.body.classList.remove('body_nav_phone');
    this.getSiteConfig();
    if (getWithExpiry('logInInfo')) {
      this.init();
    }
    // 添加点击外部关闭导航的监听
    document.addEventListener('click', this.handleOutsideClick);

    // 初始化主导航的「资源中心」下拉效果（仿官网 yssw.hongru.com）
    this.$nextTick(() => {
      this.initNav();
    });

    // 监听路由变化，关闭导航
    this.$router.afterEach(() => {
      this.closeNav();
    });
  },
  beforeDestroy() {
    // 移除监听
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    async init() {
      // 获取用户基本信息
      await getUserInfo().then((res) => {
        this.userInfo = res;
      });
    },

    // 搜索按钮点击事件
    searchBtn() {
      if (this.iptValue) {
        window.location.href = `/other/search.html?key=${this.iptValue}`;
      }
    },

    // 获取公共信息
    async getSiteConfig() {
      try {
        // 等待接口返回全量数据
        const response = await axios.get(`${process.env.VUE_APP_SHOP_API}/get-site-config`);
        this.commonInfo = response.data.data.commonInfo || {};
      } catch (error) {
        this.commonInfo = {};
      } finally {
      }
    },

    // 退出登录/登录
    logInAndlogOutClick(type) {
      if (type == 'logOut') {
        this.$confirm("确认退出当前账号吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            localStorage.removeItem('logInInfo');
            this.$router.push('/signup/login');
          })
          .catch(() => {
            // 取消删除，不做操作
          });
      } else if (type == 'logIn') {
        this.$router.push('/signup/login');
      }
    },

    // 主导航「资源中心」下拉：完全沿用官网 common.js 的 nav() 逻辑
    // 桌面端(>1024)鼠标悬停 slideDown/slideUp；移动端点击箭头 slideToggle。
    initNav() {
      const root = this.$el; // 仅作用于本组件内的导航，避免影响其它组件
      if ($(window).width() > 1024) {
        $(root).find('.nav ul>li').hover(
          function () {
            $(this).find('.navlist').stop().slideDown();
          },
          function () {
            $(this).find('.navlist').stop().slideUp();
          }
        );
      } else {
        // 移动端：标记有子菜单的箭头，点击展开/收起
        $(root).find('.navlist').siblings('span').addClass('cur');
        $(root).on('click', '.nav ul li span', function () {
          $(this).parent('li').siblings().find('span').removeClass('on');
          $(this).parent('li').siblings().find('.navlist').slideUp();
          $(this).toggleClass('on');
          $(this).siblings('.navlist').slideToggle();
        });
        // 点击子菜单链接后关闭移动端导航
        $(root).on('click', '.navlist dl dd a', () => {
          this.closeNav();
        });
      }
    },

    // 产品中心
    productListBtn() {
      if (this.$route.path !== '/product') {
        this.$router.push('/product');
      }
    },

    // 关闭导航
    closeNav() {
      this.showNav = false;
      document.body.classList.remove('body_nav_phone');
    },

    // 切换移动端导航显示
    toggleNav(e) {
      e.stopPropagation(); // 阻止事件冒泡
      this.showNav = !this.showNav;

      // 通过给body添加/移除类来控制导航显示
      if (this.showNav) {
        document.body.classList.add('body_nav_phone');
      } else {
        document.body.classList.remove('body_nav_phone');
      }
    },

    // 点击外部关闭导航
    handleOutsideClick(e) {
      const navPhoneBtn = this.$el.querySelector('.nav_phone_btn');
      const nav = this.$el.querySelector('.nav');

      // 如果点击的不是导航按钮且不是导航内部，则关闭导航
      if (this.showNav && navPhoneBtn && nav && !navPhoneBtn.contains(e.target) && !nav.contains(e.target)) {
        this.closeNav();
      }
    }
  }
}
</script>
<style scoped lang="less">
.mem_xiala {
  transition: all 0.2s;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
}

.mem:hover .mem_xiala {
  display: block;
}
</style>
